import React from "react";

import { goTo, useNavigate } from "utils";

import { Button, Col, Row, Svg, Typography } from "components";

export const ScreenError = ({ description, headline, buttonText }) => {
  const navigate = useNavigate();
  return (
    <>
      <Row>
        <Col className="center">
          <Svg svgName="misc/feedback_unhappy" height={124} width={124} />
        </Col>
      </Row>
      <Row>
        <Col>
          <Typography variant="h1" className="center">
            {headline}
          </Typography>
        </Col>
      </Row>
      <Row>
        <Col>
          <Typography variant="paragraph-m" className="margin-bottom-0 center">
            {description}
          </Typography>
        </Col>
      </Row>
      <Row>
        <Col className="center margin-bottom-400">
          <Button onClick={() => goTo(null, navigate, "/")} type="primary">
            {buttonText}
          </Button>
        </Col>
      </Row>
    </>
  );
};
